module.exports = __webpack_public_path__ + "img/6.9a0e3a2f.png";